import { render, staticRenderFns } from "./StorageTables.vue?vue&type=template&id=097d6d41&"
import script from "./StorageTables.vue?vue&type=script&lang=js&"
export * from "./StorageTables.vue?vue&type=script&lang=js&"
import style0 from "./StorageTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports